const USNoticeIncentiveLink = '/beauty/privacy-policy#USNoticeIncentive';
const TEXT_TERM_LINK = '/beauty/sms-terms-and-conditions';
const PRIVACY_POLICY_LINK = '/beauty/privacy-policy';
const TERMS_OF_USE_LINK = '/beauty/terms-of-use';

export {
    USNoticeIncentiveLink, TEXT_TERM_LINK, PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK
};
